import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "services-section",
  id: "services"
}
const _hoisted_2 = { class: "section-shell" }
const _hoisted_3 = { class: "services-grid" }
const _hoisted_4 = { class: "service-top" }
const _hoisted_5 = ["aria-label"]

import { ArrowUpRight, Building2, Flower2, Hammer, Leaf, Route, Trees } from "lucide-vue-next";
import "@/assets/styles/service.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceView',
  setup(__props) {

const services = [
  { number: "01", icon: Building2, title: "Außenanlagen", text: "Repräsentative und belastbare Freiräume für Unternehmen, Wohnanlagen und öffentliche Auftraggeber." },
  { number: "02", icon: Route, title: "Wege & Flächen", text: "Terrassen, Zufahrten und Wege mit durchdachtem Aufbau, präziser Ausführung und langlebigen Materialien." },
  { number: "03", icon: Trees, title: "Grünkonzepte", text: "Standortgerechte Pflanzung, Baumarbeiten und klimaangepasste Lösungen mit Charakter." },
  { number: "04", icon: Leaf, title: "Pflege & Service", text: "Werterhaltende Pflegekonzepte – regelmäßig, saisonal oder als verlässlicher Komplettservice." },
  { number: "05", icon: Hammer, title: "Sonderlösungen", text: "Mauern, Einfassungen, Sichtschutz und individuelle Details, die das Gesamtbild vollenden." },
  { number: "06", icon: Flower2, title: "Private Gärten", text: "Persönliche Rückzugsorte, die zu Architektur, Grundstück und Lebensstil ihrer Besitzer passen." }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "section-heading reveal" }, [
        _createElementVNode("div", null, [
          _createElementVNode("span", { class: "eyebrow" }, "Kompetenz aus einer Hand"),
          _createElementVNode("h2", null, [
            _createTextVNode("Was wir draußen"),
            _createElementVNode("br"),
            _createElementVNode("em", null, "möglich machen.")
          ])
        ]),
        _createElementVNode("p", null, "Wir übernehmen Verantwortung für das Ganze – und achten auf jedes Detail. Für Projekte, die heute überzeugen und morgen noch funktionieren.")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(services, (service) => {
          return _createElementVNode("article", {
            class: "service-card reveal",
            key: service.title
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(service.number), 1),
              (_openBlock(), _createBlock(_resolveDynamicComponent(service.icon)))
            ]),
            _createElementVNode("h3", null, _toDisplayString(service.title), 1),
            _createElementVNode("p", null, _toDisplayString(service.text), 1),
            _createElementVNode("a", {
              href: "#contact",
              "aria-label": `${service.title} anfragen`
            }, [
              _createVNode(_unref(ArrowUpRight))
            ], 8, _hoisted_5)
          ])
        }), 64))
      ])
    ])
  ]))
}
}

})